export default "__VITE_ASSET__e1dee5ad__"